<template>
  <v-data-table
    :headers="headers"
    :items="tableData"
    disable-pagination
    hide-default-header
    hide-default-footer
    disable-sort
  >
    <template v-slot:item.severity="{ item }">
      <v-icon :color="getSeverityColor(item.severity)">{{
        getSeverityIcon(item.severity)
      }}</v-icon>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-btn
        v-for="(action, i) in getActions(item)"
        :key="i"
        small
        class="flex-shrink-0 flex-grow-0 ma-1"
        :color="action.color"
        :to="action.to"
      >
        {{ $t(`feedback.actions.${action.title}`) }}
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import LogLevel from "../../../common/loglevel/LogLevel";

export default {
  name: "FeedbackTable",
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    headers: function() {
      return [
        { text: "Severity", value: "severity" },
        { text: "Message", value: "message" },
        { text: "Actions", value: "actions", align: "right" }
      ];
    },
    sorted: function() {
      let result = [];
      for (const level of LogLevel.bySeverity()) {
        result = [
          ...result,
          ...this.items.filter(feedback => feedback.severity === level)
        ];
      }
      return result;
    },
    tableData: function() {
      return this.items.length > 0
        ? this.sorted
        : [
            {
              severity: "ok",
              message: this.$t("data-export-validation.file-status-ok")
            }
          ];
    }
  },
  methods: {
    getSeverityIcon(severity) {
      if (severity === "ok") return "mdi-check-circle";
      if (this.levelAboveError(severity)) return "mdi-alert-circle";
      if (this.levelBelowNotice(severity)) return "mdi-information-outline";
      return "mdi-alert-circle-outline";
    },
    getSeverityColor(severity) {
      if (severity === "ok") return "green";
      if (this.levelAboveError(severity)) return "red";
      if (this.levelBelowNotice(severity)) return "grey";
      return "orange";
    },
    getActions(item) {
      switch (item.type) {
        case "missing-records":
          return this.getMissingRecordsActions(item);
        case "invalid-records":
          return this.getInvalidRecordsActions(item);
        case "price-for-tariff-not-set":
          return this.getMissingTariffPriceActions(item);
        case "overlapping-contract-period":
          return this.getOverlappingContractPeriodActions();
        default:
          return [];
      }
    },
    getMissingRecordsActions(item) {
      const meterUnitId =
        item?.context?._countable?.id ||
        item?.context?._countable?._meter_unit?.id;
      return [
        {
          title: "show-meter-unit",
          color: "error",
          to: {
            name: "meter-unit",
            params: {
              project_id: this.$route.params.project_id,
              id: meterUnitId
            }
          }
        }
      ];
    },
    getInvalidRecordsActions(item) {
      const meterUnitId = item?.context?._meter_unit?.id;
      return [
        {
          title: "show-meter-unit",
          color: "error",
          to: {
            name: "meter-unit",
            params: {
              project_id: this.$route.params.project_id,
              id: meterUnitId
            }
          }
        }
      ];
    },
    getMissingTariffPriceActions(item) {
      return [
        {
          title: "show-tariff",
          color: "error",
          to: {
            name: "tariff",
            params: {
              project_id: this.$route.params.project_id,
              id: item.context._tariff.id
            }
          }
        }
      ];
    },
    getOverlappingContractPeriodActions() {
      return [
        {
          title: "show-contract-periods",
          color: "error",
          to: {
            name: "contract-periods",
            params: {
              project_id: this.$route.params.project_id
            }
          }
        }
      ];
    },
    levelAboveError(severity) {
      return LogLevel.aboveSeverity(LogLevel.levels().ERROR, true).includes(
        severity
      );
    },
    levelBelowNotice(severity) {
      return LogLevel.belowSeverity(LogLevel.levels().NOTICE, true).includes(
        severity
      );
    }
  }
};
</script>

<style>
// workaround for https://github.com/vuetifyjs/vuetify/issues/8774
.v-data-table__mobile-row__header {
  display: none;
}

.v-data-table__mobile-row__cell {
  text-align: left !important;
}
</style>
